<template>
    <div id="resourceForm" class="con-exemple-prompt">
        <vs-row>
            <vs-col vs-w="12">
                 <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Type* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <multiselect
                            v-model="resource.experience_types"
                            name="addCatalogExperienceType"
                            :options="experienceTypes"
                            track-by="id"
                            label="name"
                            :multiple="true"
                            :group-select="false"
                            placeholder="Recherche ..."
                            select-label=""
                            select-group-label=""
                            selected-label=""
                            deselect-label=""
                            deselect-group-label=""
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Libellé* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.title"
                            name="addCatalogTitle"
                            class="w-full"
                            placeholder="Libellé"
                            required
                        />
                    </div>
                </div>

                <div v-if="isTraining" class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Nombre d'heure(s) :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.nb_hours"
                            name="addCatalogNbHours"
                            class="w-full"
                            type="number"
                            min="0"
                            step="1"
                        />
                    </div>
                </div>

                <div v-if="isTraining || isRAE" class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Organisme* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <template v-if="type != 'show'">
                            <div>
                                <TypeForm
                                    v-model="resource.establishment_name"
                                    resource-name="organisme"
                                    :availableTypes="establishmentNames"
                                ></TypeForm>
                            </div>
                        </template>
                        <span v-else>{{ resource.establishment_name }}</span>
                    </div>
                </div>

                <div v-if="isTraining || isRAE" class="vx-row mb-6">
                    <vs-checkbox
                        v-model="resource.is_graduate"
                        name="addCatalogIsGraduate"
                    >
                        Diplômant
                    </vs-checkbox>
                </div>
                <div class="vx-row mb-6">
                    <vs-checkbox
                        v-model="resource.active"
                        name="addCatalogActive"
                    >
                        Actif
                    </vs-checkbox>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import TypeForm from "@components/form/TypeForm";

export default {
    name: 'CatalogForm',
    components: {
        Multiselect, TypeForm
    },
    props: {
        value: {
            required: false,
            type: Object
        },
        type: {
            required: true,
            type: String
        },
        isCreation: {
            required: false,
            type: Boolean,
            default: false
        },
        establishmentNames: {
            required: false,
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            resource: {},
            experienceTypes: [],
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue === oldValue) return
            this.initResource()
        },
        'resource': {
            handler () {
                this.value.experience_types             = this.resource.experience_types;
                this.value.title                        = this.resource.title
                this.value.nb_hours                     = this.resource.nb_hours
                this.value.establishment_name           = this.resource.establishment_name
                this.value.is_graduate                  = this.resource.is_graduate
                this.value.active                       = this.resource.active
                this.$emit('input', this.value)
            }, deep: true
        },
        hasError (value) {
            this.$emit('error', value)
        }
    },
    computed: {
        /**
         * Teste si experience_types contient au moins une formation
         */
        isTraining() {
            return this.resource.experience_types?.some(e => e.category === 0) || false; // 0 = trainings, 2 = rae/vae, 5 = certificates
        },

        /**
         * Teste si experience_types contient au moins une RAE/VAE
         */
        isRAE() {
            return this.resource.experience_types?.some(e => e.category === 2) || false; // 0 = trainings, 2 = rae/vae, 5 = certificates
        },

        hasError() {
            let error = !this.resource.title
                || !this.resource.experience_types
            return error;
        },
    },
    methods: {
        async loadEstablishments() {
            return window.axios({
                method: 'get',
                url: '/api/referentiel/establishments',
                params: {perpage: 9999, include: []},
            })
            .then(response => {
                this.establishments = response.data.data;
                this.establishmentsLoading = false;
            })
            .catch((err) => {
                console.log(err)
                this.notifyError(err, `Une erreur est survenue`)
            })
        },
        async loadTrainingTypes() {
            return window
                .axios({
                    method: "get",
                    url: "/api/gestion/employees/experience-types",
                    params: { perpage: 100 }
                })
                .then(response => {
                    this.experienceTypes = response.data.data
                        .filter(e => e.category === 0 || e.category === 2 || e.category === 5);// 2 = rae/vae, 0 = trainings, 5 = certificates
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },
        initResource() {
            this.resource = {
                experience_types: this.value.experience_types,
                title: this.value.title,
                nb_hours: this.value.nb_hours,
                establishment_name: this.value.establishment_name,
                is_graduate: this.value.is_graduate,
                active: true,
            }
        },

    },
    async created() {
        this.initResource();

        this.$vs.loading();
        await Promise.all([
            this.loadEstablishments(),
            this.loadTrainingTypes()
        ]);
        this.$vs.loading.close();
    }
}
</script>

<style lang="scss" scoped>
#resourceForm {
    display: block;
    > div {
        padding: 1rem;
    }

    ::v-deep input {
        min-height: 43px;
        padding: 1rem 1.3rem;
        font-size:1.1rem;
    }
    .multiselect {
        min-height: 43px;
        &.multiselect--disabled {
            border-radius: 5px;
            ::v-deep .multiselect__select {
                border-radius: 0 4px 4px 0;
                height: 41px;
            }
        }
    }
}
</style>
